import { Observable } from 'rxjs';
import { FiltrosSolicitudNhRequest } from '../../../../../infraestructure/no-hospitalario/solicitud/dto/request/filtros-solictud-nh-request';
import { GuardarSolicitudNhRequest } from "../../../../../infraestructure/no-hospitalario/solicitud/dto/request/guardar-solicitud-nh-request";
import { PageResponse } from '../../../../../infraestructure/no-hospitalario/solicitud/dto/response/page-response';
import { Iresponse_solicitud, SolicitudNhModel } from '../entity/solicitud-nh.model';
import { CancelacionVisitaNhRequest } from './../dto/cancelacion-visita-nh-request';
import { PacienteCoberturaNh } from './../dto/paciente-cobertura-nh-dto';


export abstract class SolicitudNhGateway {

    abstract consultarSolicitudes(requestBody: FiltrosSolicitudNhRequest ): Observable<PageResponse<SolicitudNhModel>>;
    
    abstract guardarSolicitud(requestBody: GuardarSolicitudNhRequest): Observable<Iresponse_solicitud>;

    abstract consultarDatosPaciente(tipoDocumento: string, documento: string): Observable<PacienteCoberturaNh>;

    abstract consultarUltimasSolcitudesPorPaciente(tipoDocumento: string, documento: string): Observable<PageResponse<SolicitudNhModel>>;

    abstract cancelarvisita(requestBody: CancelacionVisitaNhRequest ): Observable<any>;
}
